import React from "react";
import "../logout/Logout.css";
import Footer from "../components/Footer/Footer";
import { Link, useLocation } from "react-router-dom";
import logo from "../assets/logo.png";

export default function Logout() {
	const location = useLocation();
	return (
		<>
			<div className="bg-gray-100">
				<main
					className="main-content position-relative mt-0"
					style={{ height: "89vh" }}
				>
					<div className="d-flex pt-5">
						<div className="container">
							<Link to="/">
								<div className=" top-content w-100">
									<img className="logo" src={logo} alt="logo" width="20%" />
								</div>
							</Link>
							<div
								className="row   justify-content-center"
								style={{ marginTop: " 171px!important" }}
							>
								<div className="col-xl-4 col-lg-5 col-md-7 mx-auto">
									<div className="card z-index-0">
										<div className="main-welcome">
											<div className="mb-0 position-relative text-center w-100">
												<p className="text-sm font-weight-bold mb-2 text-secondary text-border d-inline z-index-2 bg-white px-3">
													<svg
														xmlns="http://www.w3.org/2000/svg"
														width="28"
														height="30"
														viewBox="0 0 28 36"
														fill="none"
													>
														<path
															d="M0.105469 17.1924H2.02673V11.5225C2.02629 10.0093 2.32903 8.51084 2.91768 7.11275C3.50632 5.71465 4.36933 4.4443 5.45739 3.37427C6.54546 2.30424 7.83726 1.45549 9.259 0.876523C10.6807 0.297555 12.2045 -0.000290612 13.7434 1.93857e-06C15.2824 -0.000876157 16.8066 0.296562 18.2286 0.875309C19.6507 1.45406 20.9428 2.30276 22.0311 3.37289C23.1194 4.44303 23.9825 5.7136 24.571 7.11197C25.1596 8.51033 25.462 10.0091 25.4612 11.5225V17.1412C25.4374 17.1534 25.4068 17.1813 25.3785 17.1935L25.3479 17.2236H25.3378L25.3072 17.2514H25.2664L25.2359 17.2815H25.2076L25.177 17.2915H25.1645L25.1521 17.3093L25.1351 17.3215H25.1226L25.1045 17.3338L25.0921 17.3516L25.0819 17.3616L25.0638 17.3739L25.023 17.4039L24.9924 17.4206L24.9517 17.4507L24.8928 17.4741L24.8509 17.5019L24.8283 17.5197L24.8102 17.532L24.7694 17.5598L24.7388 17.572L24.6675 17.6121L24.6392 17.6299L24.6154 17.6422L24.5871 17.66H24.5747L24.4852 17.7001H24.4569L24.3562 17.7524H24.3437L24.3335 17.7702L24.2848 17.7925L24.2622 17.8103L24.2135 17.8403L24.1909 17.8504H24.1728L24.132 17.8804L24.1014 17.8927L24.0731 17.9094C24.0494 17.9216 24.0086 17.9327 23.978 17.9506L23.9497 17.9628L23.9192 17.9795L23.866 18.0029L23.8071 18.0329L23.6656 18.0908L23.6373 18.1008L23.5829 18.1309L23.5546 18.1487C21.219 19.2442 17.4863 20.3975 10.4115 20.8963C5.33488 21.2559 2.2509 23.4535 0.257177 26.092L0.105469 17.1924ZM7.41125 17.1924H20.0472V11.5225C20.0487 10.7064 19.8863 9.8981 19.5694 9.14388C19.2525 8.38967 18.7874 7.70439 18.2005 7.12736C17.6137 6.55032 16.9168 6.09288 16.1498 5.78126C15.3828 5.46965 14.5608 5.31 13.7309 5.31147C12.9011 5.31103 12.0794 5.47135 11.3126 5.78327C10.5458 6.09519 9.84902 6.5526 9.26204 7.12938C8.67507 7.70615 8.20941 8.39098 7.89165 9.14476C7.57389 9.89854 7.41026 10.7065 7.41012 11.5225L7.41125 17.1924ZM27.37 19.3611V35.625H4.03064C6.60742 34.2223 8.51283 34.3603 11.6964 34.4594C16.0201 34.5986 20.7956 32.8173 23.1414 30.4527C25.4883 28.0925 22.9365 29.8961 20.2759 30.5629C17.6153 31.2298 12.4686 31.3055 9.0257 30.4115C19.8525 30.5507 24.0799 27.1195 26.4688 24.0168C28.8565 20.9319 25.4362 23.4769 23.2127 24.5434C20.9971 25.6166 17.1217 26.3703 12.8524 25.8137C19.2977 25.7958 24.2045 22.6297 27.3575 19.36L27.37 19.3611Z"
															fill="#7F56D9"
														/>
													</svg>
												</p>
											</div>
											<div className="text-center py-4 pb-3" id="logout">
												<h4 className="text-black">
													You have been logged out Successfully
												</h4>
												<p>
													Thank you for using{" "}
													<Link className="brand-name">Bugbusterslabs</Link>{" "}
												</p>
											</div>

											<div className="mb-0 position-relative text-center w-100">
												<p className="text-sm font-weight-bold mb-2 text-secondary text-border d-inline z-index-2 bg-white px-3">
													<svg
														xmlns="http://www.w3.org/2000/svg"
														width="24"
														height="23"
														viewBox="0 0 24 23"
														fill="none"
													>
														<path
															d="M12 0C5.4 0 0 5.13 0 11.4C0 17.67 5.4 22.8 12 22.8C18.6 22.8 24 17.67 24 11.4C24 5.13 18.6 0 12 0ZM9.6 17.1L3.6 11.4L5.292 9.7926L9.6 13.8738L18.708 5.2212L20.4 6.84L9.6 17.1Z"
															fill="#44AA13"
														/>
													</svg>
												</p>
											</div>
										</div>

										<div className="card-body pt-0">
											<div className="text-center">
												<Link
													to={
														location.pathname === "/admin/logout"
															? "/admin/login"
															: location.pathname === "/customer/logout"
																? "/customer/login"
																: location.pathname === "/researcher/logout"
																	? "/researcher/login"
																	: "subadmin/login"
													}
													type="button"
													className="loginbtn btn  w-100 mt-0 mb-2"
												>
													Sign In
												</Link>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</main>
				<Footer />
			</div>
		</>
	);
}
